<script lang="ts">
  import { cn } from "@tastyworks/ui-library"
  import type { Snippet } from "svelte"

  type Alignment = "start" | "center" | "end"

  type Props = {
    class?: string | null
    alignActions?: Alignment
    children?: Snippet
  }

  let {
    class: cssClass = undefined,
    alignActions = "end",
    children,
  }: Props = $props()
</script>

<div
  class={cn("mobile:flex-col-reverse gap-extra-small flex w-full", cssClass)}
  class:justify-start={alignActions === "start"}
  class:justify-center={alignActions === "center"}
  class:justify-end={alignActions === "end"}
>
  {@render children?.()}
</div>
